// extracted by mini-css-extract-plugin
module.exports = {"container":"SaveInAppModal_container__CxtTr","content":"SaveInAppModal_content__hT8hQ","cancelIcon":"SaveInAppModal_cancelIcon__MUeCx"};